<template>
  <div style="padding: 20px">
    <!-- Dialog to confirm deletion of single pezzi -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogdeletepezziconfirmation"
      width="400"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Cancellazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di di voler eliminare questo elemento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            dark
            @click="dialogdeletepezziconfirmation = false"
            >ANNULLA</v-btn
          >
          <v-btn color="success" dark @click="delPezzi">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog to update Pezzi Object -->
    <v-dialog v-model="update_pezzi_dialog" width="800">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Modifica Pezzi</v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            colore_icona="success"
            idForm="AVANZAMENTO"
            idOggetto="SALVA_PEZZI"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva"
            v-on:buttonClick="salvaPezzi"
          />
          <v-spacer></v-spacer>
          <v-btn light small @click="update_pezzi_dialog = false">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="2">
                  <TextField
                    :readonly="true"
                    idForm="C_PEZZI"
                    idOggetto="PEZZI_RIFERIMENTO"
                    label_input="Riferimento"
                    palceholder_input="Riferimento"
                    :vmodel="riferimento"
                    v-on:changeText="(val) => (this.riferimento = val)"
                  />
                </v-col>
                <v-col cols="4">
                  <TextField
                    :readonly="true"
                    idForm="C_PEZZI"
                    idOggetto="PEZZI_COD_COMMESSA"
                    label_input="Codice Commessa"
                    palceholder_input="Codice Commessa"
                    :vmodel="cod_commessa"
                    v-on:changeText="(val) => (this.cod_commessa = val)"
                  />
                </v-col>
                <v-col cols="4">
                  <TextField
                    :readonly="true"
                    idForm="C_PEZZI"
                    idOggetto="PEZZI_COD_ARTICOLO"
                    label_input="Codice Articolo"
                    palceholder_input="Codice Articolo"
                    :vmodel="cod_articolo"
                    v-on:changeText="(val) => (this.cod_articolo = val)"
                  />
                </v-col>
                <v-col cols="2">
                  <TextField
                    :readonly="true"
                    idForm="C_PEZZI"
                    idOggetto="PEZZI_COD_FASE"
                    label_input="Codice Fase"
                    palceholder_input="Codice Fase"
                    :vmodel="cod_fase"
                    v-on:changeText="(val) => (this.cod_fase = val)"
                  />
                </v-col>
                <v-col cols="4">
                  <TextField
                    :readonly="true"
                    idForm="C_PEZZI"
                    idOggetto="PEZZI_DES_FASE"
                    label_input="Des. Fase"
                    palceholder_input="Des. Fase"
                    :vmodel="des_fase"
                    v-on:changeText="(val) => (this.des_fase = val)"
                  />
                </v-col>
                <v-col cols="3">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDate"
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        class="mt-6"
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data"
                      @input="menu3 = false"
                      locale="it"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Quantità"
                    v-model="quantita"
                    :min="0"
                    type="number"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="note"
                    placeholder="Note"
                    label="Note"
                    outlined
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-toolbar rounede dense class="white--text" color="indigo" flat>
        <v-toolbar-title>Pezzi</v-toolbar-title>
        <v-spacer></v-spacer>
        <h3>Analisi Attuale: {{ analisi }}</h3>
        <Button
          classe_bottone="ml-5 mr-5"
          colore_icona="primary"
          idForm="AVANZAMENTO"
          idOggetto="PEZZI_ANALISI_SINTETICA"
          mdi_icona="mdi-table"
          testo_tooltip="Analisi Sintetica"
          v-on:buttonClick="getAvanzamentoPezzi('s')"
        />
        <Button
          classe_bottone="mr-5"
          colore_icona="primary"
          idForm="AVANZAMENTO"
          idOggetto="PEZZI_ANALISI_DETTAGLIAATA"
          mdi_icona="mdi-table-search"
          testo_tooltip="Analisi Dettagliata"
          v-on:buttonClick="getAvanzamentoPezzi('d')"
        />

        <v-menu
          v-model="calendario_data_da"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data Da"
                v-model="data_da_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_da"
            @input="calendario_data_da = false"
          ></v-date-picker>
        </v-menu>

        <v-menu
          v-model="calendario_data_a"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data A"
                v-model="data_a_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_a"
            @input="calendario_data_a = false"
          ></v-date-picker>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="getAvanzamentoPezzi(analisi == 'sintetica' ? 's' : 'd')"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </template>
          <span>Cerca</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickAggiungiPezzi" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <Button
          classe_bottone="mr-5"
          colore_icona="primary"
          idForm="AVANZAMENTO"
          idOggetto="PEZZI_FILTRA"
          mdi_icona="mdi-filter"
          testo_tooltip="FILTRA"
          v-on:buttonClick="filtra_menu_visible = !filtra_menu_visible"
        />
        <Button
          colore_icona="primary"
          idForm="AVANZAMENTO"
          idOggetto="PEZZI_RIPRISTINA"
          mdi_icona="mdi-filter-off"
          testo_tooltip="Ripristina"
          v-on:buttonClick="ripristina"
        />
        <v-spacer></v-spacer>
        <v-btn @click="clickChiudi" color="blue-grey lighten-5" small>
          <v-icon color="error">mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5" v-if="filtra_menu_visible">
        <v-row align="center" justify="center">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="riferimento"
              item-value="riferimento"
              label="Rif. Ordine"
              style="display: inline-block; max-width: 350px"
              v-model="riferimento_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    riferimento_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    riferimento_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="cod_articolo"
              item-value="cod_articolo"
              label="Cod. Articolo"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="cod_commessa"
              item-value="cod_commessa"
              label="Cod Commessa"
              style="display: inline-block; max-width: 350px"
              v-model="cod_commessa_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_commessa_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_commessa_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="cod_macchina"
              item-value="cod_macchina"
              label="Cod. Macchina"
              style="display: inline-block; max-width: 350px"
              v-model="cod_macchina_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_macchina_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_macchina_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="nominativo"
              item-value="nominativo"
              label="Nome Operatore"
              style="display: inline-block; max-width: 350px"
              v-model="nome_operatore_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    nome_operatore_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    nome_operatore_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                items_pezzi_visualizzati.filter((e) => e.quantita != null)
              "
              item-text="quantita"
              item-value="quantita"
              label="Quantità"
              style="display: inline-block; max-width: 350px"
              v-model="qualita_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    qualita_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    qualita_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="items_pezzi[0].precent_residua" cols="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="precent_residua"
              item-value="precent_residua"
              label="Avanzamento %"
              style="display: inline-block; max-width: 350px"
              v-model="perc_avanzamento_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    perc_avanzamento_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    perc_avanzamento_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="header_pezzi"
        :items="items_pezzi_visualizzati"
        class="elevation-1"
      >
        <template v-slot:[`item.edit`]="{ item }">
          <Button
            colore_icona="primary"
            idForm="AVANZAMENTO"
            idOggetto="MODIFICA_PEZZI"
            mdi_icona="mdi-pencil"
            testo_tooltip="Aggiornare"
            v-on:buttonClick="handleClick(item)"
          />
        </template>
        <template v-slot:[`item.note`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickNote(item)"
                small
                v-show="
                  item.note != '' && item.note != undefined && item.note != null
                "
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="primary">mdi-clipboard-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Visualizza Note</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <Button
            colore_icona="error"
            idForm="AVANZAMENTO"
            idOggetto="ELIMINA_PEZZI"
            mdi_icona="mdi-window-close"
            testo_tooltip="Cancellare"
            v-on:buttonClick="seletedPezzi(item)"
          />
        </template>
      </v-data-table>
    </v-card>
    <!-- Dialog delle note -->
    <v-dialog v-model="note_dialog_visible" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Annotazioni</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="note_dialog_visible = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="text-align: left; overflow-y: auto">
          <span style="color: black; font-size: 15px">{{ note_tmp }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga pezzi -->
    <v-dialog v-model="dialog_aggiungi_pezzi" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta Riga Pezzi
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="clickSelezionaTempi"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Ricerca Tempi</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaRigaPezzi" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Riga</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_aggiungi_pezzi = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Start"
                  readonly
                  v-model="start_tmp_formattato"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Stop"
                  readonly
                  v-model="stop_tmp_formattato"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Commessa"
                  v-model="cod_commessa_tmp"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Fase"
                  v-model="cod_fase_tmp"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" justify="center">
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Macchina"
                  v-model="cod_macchina_tmp"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Quantita"
                  v-model.number="quantita_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Quantita Box"
                  v-model.number="qta_box_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Pz. Box"
                  v-model.number="qta_pz_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Peso Lordo"
                  v-model.number="peso_lordo_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Tara"
                  v-model.number="tara_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Nominativo"
                  readonly
                  v-model="nominativo_tmp"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione del tempo di produzione -->
    <v-dialog v-model="dialog_seleziona_tempi" width="unset">
      <v-card style="max-width: 800px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Tempo di Produzione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_tempi = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="4">
                <v-menu
                  v-model="calendario_tempi_data_da"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data Da"
                      v-model="tempi_data_da_formattata"
                      readonly
                      style="max-width: 150px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tempi_data_da"
                    @input="calendario_tempi_data_da = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4">
                <v-menu
                  v-model="calendario_tempi_data_a"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data A"
                      v-model="tempi_data_a_formattata"
                      readonly
                      style="max-width: 150px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tempi_data_a"
                    @input="calendario_tempi_data_a = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="getTempi" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Ricerca Tempi</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_tempi_selezionabili"
                  :items="items_tempi_selezionabili"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn small>
                      <v-icon @click="selezionaTempo(item)" color="success">
                        mdi-check
                      </v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.ora_inizio`]="{ item }">
                    {{ formatData(item.ora_inizio, "full") }}
                  </template>

                  <template v-slot:[`item.ora_fine`]="{ item }">
                    {{ formatData(item.ora_fine, "full") }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Loader -->
      <v-overlay :value="caricamento_dati_tempi">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Loader -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TextField from "../../../components/TOOLS/FormComponentPermissions/TextField";

export default {
  name: "TabellaPezziInsit",
  components: { Button, SnackbarQV, TextField },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      analisi: "",
      cod_articolo: "",
      cod_articolo_search: "",
      cod_commessa: "",
      cod_commessa_tmp: "",
      cod_commessa_search: "",
      cod_fase_tmp: "",
      cod_macchina_search: "",
      cod_macchina_tmp: "",
      cod_fase: "",
      data_a: "",
      data_da: "",
      data: "",
      des_fase: "",
      id_commessa_dettaglio_tmp: null,
      id_commessa_tmp: null,
      id_macchina_tmp: null,
      id_personale_tmp: null,
      limite_mesi_passati: 0,
      precent_residua: "",
      qta_commessa: null,
      qta_residua: null,
      quantita: null,
      nome_operatore_search: "",
      nominativo_tmp: "",
      note: "",
      note_tmp: "",
      peso_lordo_tmp: null,
      perc_avanzamento_search: null,
      qta_box_tmp: null,
      qta_pz_tmp: null,
      qualita_search: "",
      quantita_tmp: null,
      riferimento: "",
      riferimento_search: "",
      selectedItem: {},
      start_tmp: "",
      stop_tmp: "",
      tara_tmp: null,
      tempi_data_a: "",
      tempi_data_da: "",

      // Modal
      calendario_data_a: false,
      calendario_data_da: false,
      calendario_tempi_data_a: false,
      calendario_tempi_data_da: false,
      caricamento_dati: false,
      caricamento_dati_tempi: false,
      dialog_aggiungi_pezzi: false,
      dialog_seleziona_tempi: false,
      dialogdeletepezziconfirmation: false,
      filtra_menu_visible: false,
      menu3: false,
      note_dialog_visible: false,
      update_pezzi_dialog: false,

      // Array
      header_pezzi: [],
      header_pezzi_sintetico: [
        {
          text: "Rif. Ordine",
          sortable: false,
          value: "riferimento",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Des. Fase",
          sortable: false,
          value: "des_fase",
        },
        {
          text: "Data",
          sortable: false,
          value: "_data",
        },
        {
          text: "Qtà Prodotta",
          sortable: false,
          value: "quantita",
        },
        {
          text: "Qtà Da Produrre",
          sortable: false,
          value: "qta_commessa",
        },
        {
          text: "Qtà Rimanente",
          sortable: false,
          value: "qta_residua",
        },
        {
          text: "Avanzamento %",
          sortable: false,
          value: "precent_residua",
        },
        {
          text: "Causale",
          sortable: false,
          value: "causale",
        },
      ],
      header_pezzi_dettagliato: [
        { text: "Note", sortable: false, value: "note" },
        {
          text: "Rif. Ordine",
          sortable: false,
          value: "riferimento",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Des. Fase",
          sortable: false,
          value: "des_fase",
        },
        {
          text: "Data",
          sortable: false,
          value: "_data",
        },
        {
          text: "Data Dichiarazione",
          sortable: false,
          value: "_ora",
        },
        {
          text: "Turno",
          sortable: false,
          value: "cod_turno",
        },
        {
          text: "Nome",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Quantità",
          sortable: false,
          value: "quantita",
        },
        {
          text: "Causale",
          sortable: false,
          value: "causale",
        },
      ],
      headers_tempi_selezionabili: [
        {
          text: "Selezione",
          sortable: false,
          value: "selezione",
        },
        {
          text: "Start",
          sortable: false,
          value: "ora_inizio",
        },
        {
          text: "Stop",
          sortable: false,
          value: "ora_fine",
        },
        {
          text: "Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Fase",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Nominativo",
          sortable: false,
          value: "nominativo",
        },
      ],
      items_pezzi: [],
      items_pezzi_visualizzati: [],
      items_tempi_selezionabili: new Array(),
    };
  },
  methods: {
    checkModificaConsentita(arg) {
      /* Se il limite dei mesi passati è 0 vuol dire che
       * non l'ho impostato, quindi ritorno sempre true. */
      if (this.limite_mesi_passati == 0) {
        return true;
      }

      let data = moment(arg);
      let terminus_ante_quem = moment(
        `${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("YYYY")
        )}-${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("M")
        )}-01`
      );

      /* Ritorno true solo se la data passata è successiva
       * ad "adesso" meno il limite temporale consentito. */
      return data.isSameOrAfter(terminus_ante_quem);
    },
    chiudiAggiungiPezzi() {
      this.dialog_aggiungi_pezzi = false;
      this.id_commessa_tmp = null;
      this.cod_commessa_tmp = "";
      this.id_commessa_dettaglio_tmp = null;
      this.cod_fase_tmp = "";
      this.id_commessa_tempi_tmp = null;
      this.start_tmp = "";
      this.stop_tmp = "";
      this.id_macchina_tmp = null;
      this.cod_macchina_tmp = "";
      this.quantita_tmp = null;
      this.qta_box_tmp = null;
      this.qta_pz_tmp = null;
      this.tara_tmp = null;
      this.peso_lordo_tmp = null;
      this.id_personale_tmp = null;
      this.nominativo_tmp = null;
    },
    clickAggiungiPezzi() {
      this.dialog_aggiungi_pezzi = true;
    },
    clickSelezionaTempi() {
      this.dialog_seleziona_tempi = true;
    },
    clickNote(item) {
      this.note_dialog_visible = true;
      this.note_tmp = item.note;
    },
    delPezzi() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "updatecommessaquantitainsit",
          token: localStorage.getItem("user_token"),
          id_movimento: this.selectedItem.id_movimento,
          data:
            moment(this.selectedItem._data, ["DD/MM/YYYY"]).format(
              "YYYY-MM-DD"
            ) + this.selectedItem._ora.substr(10, 9),
          id_macchina: this.selectedItem.id_macchina,
          quantita: this.selectedItem.quantita,
          saldo_fase:
            this.selectedItem.saldo_fase == undefined
              ? 0
              : this.selectedItem.saldo_fase,
          validita: 0,
          id_causale: null,
          note: this.selectedItem.note,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Riga eliminata con successo."
            );
            this.dialogdeletepezziconfirmation = false;
            this.getAvanzamentoPezzi("d");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile eliminare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile cancellare i dati."
          );
        });
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    // function to select the pezzo for deletion
    seletedPezzi(item) {
      this.selectedItem = Object.assign({}, item);
      this.dialogdeletepezziconfirmation = true;
    },
    // Function in order to Populate Modal form with selected pezzi item detail
    handleClick(item) {
      let is_modifica_consentita = this.checkModificaConsentita(
        `${item._data.split("/")[2]}-${item._data.split("/")[1]}-01`
      );

      if (!is_modifica_consentita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Non è consentito modificare record così vecchi: il limite è ${
            this.limite_mesi_passati
          } ${this.limite_mesi_passati == 1 ? "mese" : "mesi"}.`
        );
        return;
      }

      this.selectedItem = Object.assign({}, item);
      this.riferimento = item.riferimento;
      this.cod_commessa = item.cod_commessa;
      this.cod_articolo = item.cod_articolo;
      this.cod_fase = item.cod_fase;
      this.des_fase = item.des_fase;
      this.data = moment(item._data, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
      this.quantita = item.quantita;
      this.qta_commessa = item.qta_commessa;
      this.qta_residua = item.qta_residua;
      this.precent_residua = item.precent_residua;
      this.note = item.note;
      this.update_pezzi_dialog = true;
    },
    // Function to Update Pezzi
    salvaPezzi() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "updatecommessaquantitainsit",
          token: localStorage.getItem("user_token"),
          id_utente: localStorage.getItem("id"),
          db_name: "quickproduction",
          id_movimento: this.selectedItem.id_movimento,
          data:
            moment(this.selectedItem._data, ["DD/MM/YYYY"]).format(
              "YYYY-MM-DD"
            ) + this.selectedItem._ora.substr(10, 9),
          id_macchina: this.selectedItem.id_macchina,
          quantita: this.quantita,
          saldo_fase:
            this.selectedItem.saldo_fase == undefined
              ? 0
              : this.selectedItem.saldo_fase,
          validita: 1,
          id_causale: null,
          note: this.note,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.update_pezzi_dialog = false;
            this.selectedItem = null;
            this.$refs.SnackbarQV.print(
              "success",
              "Dati aggiornati con successo."
            );
            this.getAvanzamentoPezzi("d");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        });
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    filtra() {
      let items_pezzi_tmp = [];
      this.items_pezzi.forEach((elem) => {
        items_pezzi_tmp.push(elem);
      });
      // Filtro il riferimento ordine
      if (this.riferimento_search != "") {
        // Faccio un array temporaneo
        let res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_pezzi_tmp.forEach((elem) => {
          if (elem.riferimento == this.riferimento_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_pezzi_tmp = res;
      }
      // Filtro il cod_articolo
      if (this.cod_articolo_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.cod_articolo == this.cod_articolo_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      //Filtro il codice Commessa
      if (this.cod_commessa_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.cod_commessa == this.cod_commessa_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      // Filtro il codice macchina
      if (this.cod_macchina_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.cod_macchina == this.cod_macchina_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      // Filtro il nome dell'operatore
      if (this.nome_operatore_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.nominativo == this.nome_operatore_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      // Filtro la percentuale di avanzamento
      if (this.perc_avanzamento_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.precent_residua === this.perc_avanzamento_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }

      // Filtro la qualita
      if (this.qualita_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.quantita == this.qualita_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      this.items_pezzi_visualizzati = [];
      this.items_pezzi_visualizzati = items_pezzi_tmp;
    },
    getAvanzamentoPezzi(param) {
      const data_a_tmp = this.data_a.substr(0, 10);
      const data_da_tmp = this.data_da.substr(0, 10);

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaavanzamento",
          token: localStorage.getItem("user_token"),
          tipo: "p",
          analisi: param,
          data_da: data_da_tmp,
          data_a: data_a_tmp,
        },
      };
      this.caricamento_dati = true;
      this.$store.dispatch("api", request).then((res) => {
        // Definisco il tipo di analisi corrente in base alla chiamata
        this.analisi = param == "s" ? "sintetica" : "dettagliata";
        // Svuoto l'array che contiene i dati dell'avanzamento
        this.items_pezzi = [];
        this.items_pezzi = res.data;

        // Svuoto lo header dei e lo ripopolo a seconda dell'analisi
        if (param == "s") {
          this.header_pezzi = [];
          this.header_pezzi_sintetico.forEach((elem) => {
            this.header_pezzi.push(elem);
          });
        } else if (param == "d") {
          this.header_pezzi = [];
          this.header_pezzi_dettagliato.forEach((elem) => {
            this.header_pezzi.push(elem);
          });
          let data2 = {
            value: "edit",
            sortable: false,
          };
          this.header_pezzi.unshift(data2);
          let data1 = {
            value: "delete",
            sortable: false,
          };
          this.header_pezzi.push(data1);
        }
        this.caricamento_dati = false;
      });
    },
    getTempi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdatitempi",
          token: localStorage.user_token,
          start: this.tempi_data_da,
          stop: this.tempi_data_a,
        },
      };

      this.caricamento_dati_tempi = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati_tempi = false;
          if (res.status === 200) {
            this.items_tempi_selezionabili = res.data.result.tempi;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati_tempi = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getVincoliModifica() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "CONSUNTIVI_PEZZI",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni per questo modulo, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              ).length > 0
            ) {
              this.limite_mesi_passati = res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    ripristina() {
      // Resetto i valori dei filtri
      this.riferimento_search = "";
      this.cod_articolo_search = "";
      this.cod_macchina_search = "";
      this.nome_operatore_search = "";
      this.qualita_search = "";
      // Resetto i valori della tabella
      this.items_pezzi_visualizzati = [];
      this.items_pezzi.forEach((elem) => {
        this.items_pezzi_visualizzati.push(elem);
      });
    },
    salvaRigaPezzi() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "addrigapezzi",
          token: localStorage.user_token,
          pezzi: [
            {
              quantita: this.quantita_tmp,
              qta_box: this.qta_box_tmp,
              qta_pz: this.qta_pz_tmp,
              id_commessa: this.id_commessa_tmp,
              id_commessa_dettaglio: this.id_commessa_dettaglio_tmp,
              id_commessa_tempi: this.id_commessa_tempi_tmp,
              id_macchina: this.id_macchina_tmp,
              id_personale: this.id_personale_tmp,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_aggiungi_pezzi = false;
            this.quantita_tmp = null;
            this.qta_box_tmp = null;
            this.qta_pz_tmp = null;
            this.id_commessa_tmp = null;
            this.cod_commessa_tmp = "";
            this.id_commessa_dettaglio_tmp = null;
            this.cod_fase_tmp = "";
            this.id_commessa_tempi_tmp = null;
            this.id_macchina_tmp = null;
            this.cod_macchina_tmp = "";
            this.id_personale_tmp = "";
            this.nominativo_tmp = "";

            this.getAvanzamentoPezzi(this.analisi == "sintetica" ? "s" : "d");

            this.$refs.SnackbarQV.print(
              "success",
              "Produzione registrata con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    selezionaTempo(arg) {
      this.id_commessa_tmp = arg.id_commessa;
      this.cod_commessa_tmp = arg.cod_commessa;
      this.start_tmp = arg.ora_inizio;
      this.stop_tmp = arg.ora_fine;
      this.id_commessa_dettaglio_tmp = arg.id_commessa_dettaglio;
      this.cod_fase_tmp = arg.cod_fase;
      this.id_macchina_tmp = arg.id_macchina;
      this.cod_macchina_tmp = arg.cod_macchina;
      this.id_personale_tmp = arg.id_personale;
      this.nominativo_tmp = arg.nominativo;

      this.dialog_seleziona_tempi = false;
      this.items_tempi_selezionabili = new Array();
    },
  },
  mounted() {
    this.getVincoliModifica();

    this.data_a = moment().format("YYYY-MM-DD");
    this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.tempi_data_a = moment().format("YYYY-MM-DD");
    this.tempi_data_da = moment().subtract(7, "days").format("YYYY-MM-DD");

    this.getAvanzamentoPezzi("s");
  },
  computed: {
    data_a_formattata() {
      return this.data_a != "" ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
    formatDate() {
      return this.data ? moment(this.data).format("DD/MM/YYYY") : "";
    },
    start_tmp_formattato() {
      return this.start_tmp != ""
        ? moment(this.start_tmp).format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    stop_tmp_formattato() {
      return this.stop_tmp != ""
        ? moment(this.stop_tmp).format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    tempi_data_a_formattata() {
      return this.tempi_data_a != ""
        ? moment(this.tempi_data_a).format("DD/MM/YYYY")
        : "";
    },
    tempi_data_da_formattata() {
      return this.tempi_data_da != ""
        ? moment(this.tempi_data_da).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    items_pezzi: {
      immediate: true,
      deep: true,
      handler() {
        this.items_pezzi_visualizzati = [];
        this.items_pezzi.forEach((elem) => {
          elem.data_js = moment(
            elem._data.substring(6, 10) +
              "-" +
              elem._data.substring(3, 5) +
              "-" +
              elem._data.substring(0, 2)
          );
          // Aggiungo gli items ai pezzi visualizzati
          this.items_pezzi_visualizzati.push(elem);
        });
        // Eseguo un filtro, caso mai l'utente ne abbia messo uno.
        this.filtra();
      },
    },
  },
};
</script>
<style>
.custom-label-color .v-label {
  color: white !important;
  opacity: 1;
}
</style>
